import './chunk-b91774bc.js';
import './helpers.js';
import './chunk-b76a6c1d.js';
import './chunk-0ff68bf2.js';
import './chunk-634a5d07.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-69127362.js';
import './chunk-b3471279.js';
import './chunk-d370ecc5.js';
import './chunk-b0139d4f.js';
import './chunk-c7f9c582.js';
import { D as Datepicker } from './chunk-910c48e8.js';
export { D as BDatepicker } from './chunk-910c48e8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;
